/**
 * AccountNameEdit component module.
 * @module advisor/shared/components/AccountNameEdit
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import {isEntitled} from '../../../shared/reducers/user';
import {Icon, Row} from '../../../shared';
import {PORTAL_NAME} from '../../../config';

const AccountNameEdit = (props) => {
  const {account: {id, displayName, originalName, containerID}, size, openModal, dataManager} = props;

  const _cellSection = styled.span`
    text-align: left;
  `;

  return <Row width={'70px'} layout={{grow: 1}} wrap={false} alignItems={'middle'} justifySubRow={'left'} height={'100%'}>
    <_cellSection>
      {displayName}
    </_cellSection>
    {PORTAL_NAME !== 'widgets' && isEntitled([{group: 'account', feature: 'core', access: 'u'}]) && size.width > 950
      ? <Icon svg={'circleEdit'} width={'20px'} action={() => openModal({
        type: 'EditAccountNameModal',
        containerID: containerID,
        account: {
          id: id,
          displayName: displayName,
          originalName: originalName,
        },
        action: dataManager.refresh,
      })}/> : null}
  </Row>;
};

export default AccountNameEdit;

AccountNameEdit.propTypes = {
  /**
   * Account information
   */
  account: PropTypes.shape({
    id: PropTypes.number.isRequired,
    containerID: PropTypes.number.isRequired,
    displayName: PropTypes.string.isRequired,
    originalName: PropTypes.string,
  }),
  /**
   * Size of parent container
   */
  size: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number,
  }),
  /**
   * Function to open modal
   */
  openModal: PropTypes.func,
  /**
   * DataManager for data of parent
   */
  dataManager: PropTypes.object,
};
